import * as navigation from 'Navigation';

export default class ConnectionDataTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Data',
      closeable: false,
      preferenceKey: 'connection-data',
    };
  }
}
